import axios from 'axios';
import { isServer, settings } from '../settings';
import { getAccessToken } from 'services/auth';

const commentsService = (accessToken) => {
  return axios.create({
    baseURL:
      (isServer && settings.API_SERVICE_INTERNAL_URL_COMMENTS) || settings.API_SERVICE_URL_COMMENTS,
    timeout: isServer ? 2000 : 10000,
    headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
  });
};

export const getCommentsData = async ({ itemId, accessToken }) =>
  commentsService(accessToken).get(`/articles/${itemId}/comments`);

export const getModeratorCommentsData = async ({ itemId, accessToken }) =>
  commentsService(accessToken).get(`/articlesmod/${itemId}/comments`);

export const postComment = async ({ itemId, parentId = '', content, referenceId = '' }) => {
  const body = {
    content,
    parent_id: parentId,
    reference_id: referenceId,
  };
  return commentsService(await getAccessToken()).post(
    `/articles/${itemId.replace('_', '/')}/comments`,
    body,
  );
};

export const kudoComment = async ({ commentId, direction }) => {
  const body = {
    vote: direction,
  };
  return commentsService(await getAccessToken()).post(`/comments/commentkudos/${commentId}`, body);
};

export const reportComment = async (commentId) => {
  return commentsService(await getAccessToken()).post(`/comments/commentreport/${commentId}`, {});
};

export const moderateComment = async ({ commentId, action }) => {
  const body =
    action === 'wegjorissen'
      ? { approve_action: '1', ban_action: '0' }
      : { approve_action: '0', ban_action: '1' };
  return commentsService(await getAccessToken()).put(`/moderate/${commentId}/`, body);
};

export const moderateArticle = async ({ commentId }) => {
  return commentsService(await getAccessToken()).put(`/moderate/moderated_at_com/${commentId}`);
};

export const getBadges = async ({ username }) => {
  return commentsService(await getAccessToken()).get(`/badges/${username}`);
};

export const getStats = async () => {
  return commentsService(await getAccessToken()).get('/statistieken');
};

export const getUnmoderatedCommentsList = async (ids) => {
  return commentsService(await getAccessToken()).post('/get-unmoderated-comments', { ids });
};

export const getTopComments = async ({ username, accessToken }) =>
  commentsService(accessToken).get(`/my-comments-kudo/${username}`);

export const getPersonalStats = async ({ username, accessToken }) =>
  commentsService(accessToken).get(`/stats/general/${username}`);
export const getProfileComments = async ({ username, accessToken }) =>
  commentsService(accessToken).get(`/my-profile-comments/${username}`);
export const getProfileBadges = async ({ username, accessToken }) =>
  commentsService(accessToken).get(`/badges/${username}`);

export const toggleBadges = async () => {
  return commentsService(await getAccessToken()).post('/toggleBadges');
};
